const PortfolioData = [
  {
    id: 1,
    title: "Protask Dashboard",
    image: "/protask-dashboard 1.png",
    small_description:
      "A full-featured productivity dashboard built with React, RESTful APIs, CI/CD pipelines, testing, and state management. Includes task CRUD, charts, dark mode, responsive design, and Figma-based UI/UX.",
    long_description:
      "ProTask is a personal project showcasing my ability to build end-to-end, production-ready applications with React. It functions as a productivity dashboard that helps users manage tasks, track progress, and gain insights through charts and statistics. Beyond frontend development, this project demonstrates API integration, CI/CD pipelines, automated testing, and design-to-code implementation from Figma. It highlights my skills in modern frontend engineering practices, collaboration workflows, and professional deployment pipelines.",
    description_images: [
      "/protask-dashboard 1.png",
      "/protask-dashboard 2.png",
      "/protask-dashboard 3.png",
    ],
    tech_stack: [
      "React",
      "JavaScript",
      "Axios",
      "CSS",
      "HTML",
      "Figma",
      "Github Actions (CI/CD)",
      "RESTful API",
      "Jest",
      "React Testing Library",
    ],
    concepts_practised: [
      "Implemented full CRUD operations (Create, Read, Update, Delete) for task management.",
      "Integrated RESTful APIs to persist and retrieve task data.",
      "Set up CI/CD pipelines with GitHub Actions for automated builds, tests, and deployments.",
      "Implemented CI/CD pipelines using GitHub Actions for automated testing and deployment to Vercel",
      "Integrated commit linting and pre-commit hooks (simple-git-hooks, commitlint) to enforce clean commit standards",
      "Practiced frontend testing with Jest and React Testing Library for unit and integration tests.",
      "Applied state management using React Context API and hooks (useState, useEffect, useContext).",
      "Designed and implemented dark mode and light mode for better accessibility.",
      "Visualized task completion and productivity trends with Recharts.",
      "Recreated a Figma design for a modern, consistent UI/UX. (https://www.figma.com/design/W0WJAUkSBzgMI9zYrIJ94S/Task-Manager-webDesign--Community-?node-id=1-2711&m=draw)" ,
      "Followed semantic HTML, accessibility best practices, and responsive design principles.",
      "Practiced Git and GitHub workflows including branching, commits, version control, and protected environments.",
    ],
    live_preview: "https://protask-dashboard.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/protask-dashboard",
  },
  {
    id: 2,
    title: "E-Commerce Platform",
    image: "/Ecommerce 1.png",
    small_description:
      "Full-stack MERN E-commerce app with user authentication, AI chatbot, dynamic products, cart, wishlist, and secure payments. Focused on accessibility, performance, and end-to-end development.",
    long_description:
      "This E-commerce platform is a personal full-stack project showcasing my growth from frontend to full-stack development. Originally built with React as my first post-course project after completing FreeCodeCamp’s React curriculum, I later converted it into a full-stack MERN application. I designed, developed, and integrated both the frontend and backend, demonstrating end-to-end web development proficiency. This project applied the following:",
    description_images: [
      "/Ecommerce 1.png",
      "/Ecommerce 2.png",
      "/Ecommerce 3.png",
    ],
    tech_stack: [
      "MongoDB",
      "Express",
      "React",
      "Node",
      "CSS",
      "HTML",
      "Github",
      "Figma",
    ],
    concepts_practised: [
      "Built full RESTful APIs using Express.js and Node.js.",
      "Integrated MongoDB for persistent product, user, and cart data storage.",
      "Implemented JWT-based user authentication and route protection.",
      "Connected frontend and backend seamlessly using Fetch API and route configurations.",
      "Recreated a Figma design: (https://www.figma.com/design/noB6Ao9cDlRHCNbJiZgNWP/Full-E-Commerce-Website-UI-UX-Design-(Community)?node-id=1-3&p=f&t=10m0lgK9jcLG9kXW-0)",
      "Implemented AI chatbot for user support using Gemini API.",
      "Used React Router for dynamic page navigation and structured routing.",
      "Managed state with useState, useContext, and useRef hooks.",
      "Applied Git and GitHub best practices: branch creation, API key protection with .env, repo reset, and project version control.",
      "Built the application with a focus on accessibility, responsiveness, and performance.",
    ],
    live_preview: "https://e-commerce-six-tau-65.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/eCommerce",
  },
  {
    id: 3,
    title: "Dontests",
    image: "/DonTests slide 1.png",
    small_description:
      "A well test analysis tool for petroleum engineers that plots pressure-time semilog graphs, performs calculations, generates tables, and provides reservoir interpretations.",
    long_description:
      "This petroleum engineering well test tool is designed to assist in reservoir analysis by automating key well test processes. It generates pressure-time semilog plots, performs essential calculations, and constructs detailed tables to support decision-making. This application enhances efficiency and accuracy in petroleum engineering workflows. The following are the frontend tools I used to bring this project to life:",
    description_images: [
      "/Dontests 2 slide.png",
      "/DonTests slide 1.png",
      "/DonTests slide 3.png",
    ],
    tech_stack: ["JavaScript", "CSS", "HTML", "D3.js", "MathJax", "Github"],
    concepts_practised: [
      "The web application processes three different types of files xlsx, csv and xls so I had to develop for them.",
      "The web application does three different types of tests (drawdown buildup and variable rate tests). ",
      "The web application implements error handling ",
      "Learnt and Implemented D3.js for Drawing the chart",
      "Learnt and Implemented Mathjax.js for writing  the mathematical euations",
      "Designed the site to be fully responsive across both mobile and desktop devices.",
      "Developed a UI/UX design from my own imagination.",
      "Deepened my understanding of Git and GitHub for version control, learning how to create, manage, and push branches, resolve push errors, protect API keys using .env, reset a Git repository, and start fresh while following best practices",
      "By building this Dontests, I strengthened my frontend development skills while demonstrating my ability to create well-structured, maintainable, and user-friendly web applications.",
    ],
    live_preview: "https://dontests.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/DonTests",
  },
  {
    id: 4,
    title: "Portfolio",
    image: "/Portfolio Slide 3.png",
    small_description:
      "A fully responsive and accessible portfolio website built with React, showcasing my projects and skills. Developed with Git, GitHub, React Router, and best practices in UI/UX, responsiveness, and accessibility.",
    long_description:
      "This portfolio website is a personal project designed to showcase my skills, projects, and experiences as a frontend developer. It is the second project I have worked on since completing my React course by freeCodeCamp. The following tools are extensions of what I learned in my freeCodeCamp lessons:",
    description_images: [
      "/Portfolio Slide 1.png",
      "/Portfolio Slide 2.png",
      "/Portfolio Slide 3.png",
    ],
    tech_stack: ["React", "CSS", "HTML", "Github", "Figma"],
    concepts_practised: [
      "Dynamic navigation using React Router, Page structure, useContext() for a seamless browsing experience.",
      "Recreation of Figma design: (https://www.figma.com/design/Su9RVJZDbtwG3PZ7VBFB1m/Developer-Portfolio-Design-(Community)?node-id=1-4&t=2B6Ss4aROUXRPNaq-0)",
      "Designed the site to be fully responsive across both mobile and desktop devices.",
      "Followed accessibility best practices by implementing structured and semantic HTML to enhance usability for all users.",
      "Recreated a UI/UX design with attention to detail.",
      "Light and Dark mode in React implementation.",
      "Deepened my understanding of Git and GitHub for version control, learning how to create, manage, and push branches, resolve push errors, protect API keys using .env, reset a Git repository, and start fresh while following best practices in a React project.",
      "Explored and applied useState for state management.",
      "Utilized useRef for handling references within components.",
      "By building this portfolio, I strengthened my frontend development skills while demonstrating my ability to create well-structured, maintainable, and user-friendly web applications.",
    ],
    live_preview: "https://josephdonportfolio.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/Portfolio",
  },
  {
    id: 5,
    title: "Question and Answer",
    image: "/Q and A 3.png",
    small_description:
      "I believe frontend development is about making things happen. This mobile Q&A app is a personal project I created to study more efficiently, whenever and wherever.",
    long_description:
      "This project takes in an excel file containing already prepared question and answers. I had to reinforce the following knowledge while working on this project:",
    description_images: ["/Q and A 1.png", "/Q and A 2.png", "/Q and A 3.png"],
    tech_stack: ["JavaScript", "CSS", "HTML", "Github"],
    concepts_practised: [
      "The web application processes three different types of files xlsx, csv and xls so I had to develop for them.",
      "Designed the site to be fully responsive across both mobile and desktop devices.",
      "Developed a UI/UX design from my own imagination.",
      "Asynchronous JavaScript and APIs (AJAX/Fetch)",
      "DOM Manipulation",
      "Promises and Async/Await",
      "Data Structures (Arrays, Functions and Objects)",
      "Dynamic UI updates",
    ],
    live_preview: "https://question-bank-rouge.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/Question-Bank",
  },
  {
    id: 6,
    title: "Chef Claude",
    image: "/Chef Claude 2.png",
    small_description:
      "Chef Claude is a React project designed to solidify advanced React concepts.",
    long_description:
      "A capstone project from free code camp to demonstrate mastery of state management, AI usage in React, component composition, and dynamic rendering. The following were practiced:",
    description_images: [
      "/Chef Claude 1.png",
      "/Chef Claude 2.png",
      "/Chef Claude 3.png",
    ],
    tech_stack: ["React", "CSS", "HTML", "Github"],
    concepts_practised: ["AI usage", "useState", "useRef", "Api"],
    live_preview: "https://chef-claude-joe.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/chefClaude",
  },
  {
    id: 7,
    title: "Image-Search-App",
    image: "/Image Search 2.png",
    small_description:
      "An Image Search web application built with HTML, CSS, and JavaScript. It allows users to search for images using an external API and displays the results dynamically.",
    long_description:
      "This Image Search application allows users to search for images by entering keywords, retrieving results from an external image API, and displaying them in a user-friendly grid. Built with HTML, CSS, and JavaScript, this project demonstrates several important frontend development concepts. Here's a breakdown of the JavaScript skills required:",
    description_images: [
      "/Image Search 1.png",
      "/Image Search 2.png",
      "/Image Search 3.png",
    ],
    tech_stack: ["JavaScript", "CSS", "HTML", "Github"],
    concepts_practised: [
      "Asynchronous JavaScript and APIs (AJAX/Fetch)",
      "DOM Manipulation",
      "Respnsive design for mobile and desktop.",
      "Promises and Async/Await",
      "Data Structures (Arrays, Functions and Objects)",
      "Dynamic UI updates",
    ],
    live_preview: "https://dons-image-search-app.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/Image-Search-App",
  },
  {
    id: 8,
    title: "Assembly: Endgame",
    image: "/Assembly 1.png",
    small_description:
      "Assembly: Endgame is a React project designed to solidify advanced React concepts.",
    long_description:
      "A capstone project from free code camp to demonstrate mastery of state management, component composition, and dynamic rendering. The following were practiced:",
    description_images: [
      "/Assembly 1.png",
      "/Assembly 3.png",
      "/Assembly 2.png",
    ],
    tech_stack: ["React", "CSS", "HTML", "Github"],
    concepts_practised: ["React rendering", "useState", "useRef"],
    live_preview: "https://assembly-endgame-chi.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/Assembly-Endgame",
  },
  {
    id: 9,
    title: "Scientific-calculator",
    image: "/Calculator 2.png",
    small_description:
      "A fully functional scientific calculator web application built using HTML, CSS, and JavaScript. It provides standard arithmetic operations and advanced scientific functions.",
    long_description:
      "This project is a scientific calculator web application, constructed using the foundational web technologies: HTML for structure, CSS for styling, and JavaScript for interactivity and logic. In building this calculator, I applied my solid understanding of several key JavaScript concepts, which are:",
    description_images: [
      "/Calculator 1.png",
      "/Calculator 2.png",
      "/Calculator 3.png",
    ],
    tech_stack: ["JavaScript", "CSS", "HTML", "Github"],
    concepts_practised: [
      "Object Oriented Programming",
      "DOM and String Manipulation",
      "Event Handling",
      "Mathematical Functions",
      "Functions",
    ],
    live_preview: "https://josephdons-scientific-calculator.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/Scientific-calculator",
  },
  {
    id: 10,
    title: "Tenzis-game",
    image: "/Tenzis 1.png",
    small_description:
      "Tenzis-game is a React project designed to solidify advanced React concepts.",
    long_description:
      "A capstone project from free code camp to demonstrate mastery of state management, AI usage in React, component composition, and dynamic rendering. The following were practiced:",
    description_images: ["/Tenzis 2.png", "/Tenzis 1.png", "/Tenzis 3.png"],
    tech_stack: ["React", "CSS", "HTML", "Github"],
    concepts_practised: ["useState", "useRef", "Component Management"],
    live_preview: "https://dons-tenzis-game.vercel.app/",
    view_code: "https://github.com/AdeJosephdon/Tenzis-game",
  },
  {
    id: 11,
    title: "Product Store",
    image: "/Product Store 3.png",
    small_description: "A full-stack application applying CRUD principles.",
    long_description:
      "This project is a full stack application built using React and backend API built using Express and Node.js, which allows the management of product data in an e-commerce-like system. The backend connects to a MongoDB database to store, retrieve, and manage products. It provides CRUD (Create, Read, Update, Delete) functionality to allow easy interaction with the product data. The following were practiced:",
    description_images: [
      "/Product Store 1.png",
      "/Product Store 3.png",
      "/Product Store 2.png",
    ],
    tech_stack: [
      "React",
      "CSS",
      "HTML",
      "Github",
      "Node",
      "MongoDB",
      "Express",
      "Axios",
    ],
    concepts_practised: [
      "Frontend-Backend connection",
      "Database Integration with MongoDB",
      "HTTP Methods and Status Codes",
      "API Testing and Debugging",
      "API Design",
      "CRUD Operations",
      "Debugging and Error Handling",
      "Modeling Data with Mongoose",
      "Axios",
    ],
    live_preview: "https://mern-course-aykc.onrender.com/",
    view_code: "https://github.com/AdeJosephdon/mern-course/",
  },
];

export default PortfolioData;
